import { AppConfigService } from './../../../services/app-config/app-config.service';
import { DialogAlertComponent } from './../dialog-alert/dialog-alert.component';
import { CheckoutService } from './../../../services/checkout/checkout.service';
import { AuthenticationService } from './../../../services/authentication/authentication.service';
import { MdDialogRef, MD_DIALOG_DATA, MdDialog } from '@angular/material';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'act-dialog-budget-suggestion',
  templateUrl: './dialog-budget-suggestion.component.html',
  styleUrls: ['./dialog-budget-suggestion.component.scss']
})
export class DialogBudgetSuggestionComponent implements OnInit {
  public pageElementName = 'dialog-budget-suggestion';
  public budgetValue: number;
  public isSubmitted = false;
  public isLoading = false;
  public oneMillion = 1000000;

  public budgetMask = [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  constructor(
    public dialogRef: MdDialogRef<DialogBudgetSuggestionComponent>,
    private checkoutService: CheckoutService,
    private dialog: MdDialog,
    private appConfigService: AppConfigService,
    @Inject(MD_DIALOG_DATA) private existBudget: number
  ) { }

  ngOnInit() {
    this.budgetValue = this.existBudget;
  }

  handleCancel() {
    this.dialogRef.close();
  }

  onApplyBudget() {
    this.isSubmitted = true;
    if (!this.isValid()) {
      return;
    }
    this.isLoading = true;
    this.checkoutService.saveBudgetSuggestion(this.budgetValue)
      .subscribe(
        () => this.dialogRef.close(this.budgetValue),
        error => {
          let errorCode: string;
          try {
            const errorList: any[] = error.json().errors;
            errorCode = errorList.length > 0 ? errorList[0].code : '';
          } catch (e) {
            console.log(e);
          }
          this.dialogRef.close();
          const dialogAlertRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent);

          dialogAlertRef.componentInstance.alertText = this.appConfigService.getTranslate('system-error');
          dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
          dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';

          if (errorCode)
            switch (errorCode) {
              case '4500':
              case '4501':
              case '4502':
              case '4503':
              case '4504':
                dialogAlertRef.componentInstance.imageSrc = 'assets/images/icons/icon-failed.png';
                dialogAlertRef.componentInstance.imageSrcSet = 'assets/images/icons/icon-failed.png';
                dialogAlertRef.componentInstance.alertText = this.appConfigService.getTranslate('checkout-3-error-multi-payment-not-allow');
                break;
            }
        });
  }

  isValid() {
    return this.budgetValue && this.budgetValue <= this.oneMillion
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-budget-suggestion/dialog-budget-suggestion.component.ts